import logoUrl from '/logo.png';

/**
 * ⚠️ SITE CHROME: KEEP IN SYNC across products.
 * Duplicated (AIVS is a standalone app). Change the header/footer? Update ALL:
 *   1. pagecoder (slidecoder theme): src/components/Header.tsx + Footer.tsx  ← canonical
 *   2. pagecoder-aio-scan: frontend/src/components/SiteHeader.tsx + SiteFooter.tsx  ← this
 *   (pagecoder-rag-chat is a WP plugin, no own chrome; its pages use the theme.)
 *
 * Site footer matching pagecoder.ai (slidecoder theme). Links back to the main site. */
export default function SiteFooter(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <footer className="px-6 pt-16 pb-10 mt-16 bg-footer-bg">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10 pb-10 border-b border-white/5">
          <div className="max-w-sm">
            <a href="https://pagecoder.ai/" className="inline-flex items-center gap-2 font-semibold text-xl" style={{ fontFamily: "'Inter', system-ui, sans-serif", letterSpacing: '-0.015em' }}>
              <img src={logoUrl} alt="" width={40} height={40} className="shrink-0" aria-hidden="true" />
              <span className="text-text-primary">PageCoder</span>
              <span className="text-text-secondary">.ai</span>
            </a>
            <p className="font-sans text-sm text-text-secondary/70 mt-4 leading-relaxed">
              Privacy-first AI tools for honest businesses. Your content stays on your server. This is a stateless math
              service, not a data hoarder.
            </p>
          </div>

          <nav className="flex flex-col sm:flex-row gap-10 sm:gap-16 text-sm">
            <div>
              <div className="font-mono text-sm uppercase tracking-[0.14em] text-text-secondary/50 mb-3">Product</div>
              <ul className="space-y-2">
                <li><a href="/ai-visibility-scan" className="text-text-secondary hover:text-cyan transition-colors">AI Visibility Scan</a></li>
                <li><a href="https://pagecoder.ai/products/rag-chat" className="text-text-secondary hover:text-cyan transition-colors">RAG Chat</a></li>
                <li><a href="https://pagecoder.ai/about" className="text-text-secondary hover:text-cyan transition-colors">Work with me</a></li>
                <li><a href="https://pagecoder.ai/contact" className="text-text-secondary hover:text-cyan transition-colors">Contact</a></li>
              </ul>
            </div>
            <div>
              <div className="font-mono text-sm uppercase tracking-[0.14em] text-text-secondary/50 mb-3">Legal</div>
              <ul className="space-y-2">
                <li><a href="https://pagecoder.ai/legal/privacy" className="text-text-secondary hover:text-cyan transition-colors">Privacy Policy</a></li>
                <li><a href="https://pagecoder.ai/legal/terms" className="text-text-secondary hover:text-cyan transition-colors">Terms of Service</a></li>
                <li><a href="https://pagecoder.ai/legal/cookies" className="text-text-secondary hover:text-cyan transition-colors">Cookies</a></li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between gap-3 font-mono text-sm text-text-tertiary">
          <div>© {year} PageCoder.ai. All rights reserved.</div>
          <div>Made in EU · GDPR-compliant by design</div>
        </div>
      </div>
    </footer>
  );
}
